module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fx fx-y-center"
  }, [_c('div', {
    staticClass: "title fx w120 m-r-5"
  }, [_c('p', {
    staticClass: "ask-cont"
  }, [(_vm.isMust) ? _c('i', {
    staticClass: "ask"
  }, [_vm._v("*")]) : _vm._e()]), _c('span', {
    staticClass: "fx-fill"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
    staticClass: "fx-fill"
  }, [(_vm.type == 'text' || _vm.type == 'tel' || _vm.type == 'email') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentValue),
      expression: "currentValue"
    }],
    staticClass: "input b-r-5",
    attrs: {
      "type": "type",
      "maxlength": _vm.maxlength,
      "disabled": _vm.disabled,
      "placeholder": _vm.placeholderDefult
    },
    domProps: {
      "value": (_vm.currentValue)
    },
    on: {
      "change": function($event) {
        return _vm.$emit('change', _vm.currentValue)
      },
      "blur": _vm.handleBlur,
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleKeyEnter($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentValue = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type == 'password') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentValue),
      expression: "currentValue"
    }],
    staticClass: "input b-r-5",
    attrs: {
      "type": "password",
      "maxlength": _vm.maxlength,
      "disabled": _vm.disabled,
      "placeholder": _vm.placeholderDefult
    },
    domProps: {
      "value": (_vm.currentValue)
    },
    on: {
      "change": function($event) {
        return _vm.$emit('change', _vm.currentValue)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentValue = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type == 'number') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentValue),
      expression: "currentValue"
    }],
    staticClass: "input b-r-5",
    attrs: {
      "type": "number",
      "maxlength": _vm.maxlength,
      "disabled": _vm.disabled,
      "placeholder": _vm.placeholderDefult
    },
    domProps: {
      "value": (_vm.currentValue)
    },
    on: {
      "change": function($event) {
        return _vm.$emit('change', _vm.currentValue)
      },
      "blur": _vm.handleBlur,
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleKeyEnter($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentValue = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type == 'textarea') ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentValue),
      expression: "currentValue"
    }],
    staticClass: "edit b-r-5",
    attrs: {
      "maxlength": _vm.maxlength,
      "placeholder": _vm.placeholderDefult
    },
    domProps: {
      "value": (_vm.currentValue)
    },
    on: {
      "change": function($event) {
        return _vm.$emit('change', _vm.currentValue)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentValue = $event.target.value
      }
    }
  }) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-f44df23c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/zui/Input.vue
// module id = 893
// module chunks = 0